<template>
  <el-input-number v-bind="$attrs" ref="input" v-model="myVal" v-on="$listeners"></el-input-number>
</template>
<script>
export default {
  props: {
    value: {},
  },
  computed: {
    myVal: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      },
    },
  },
  mounted() {
    this.$refs.input.$refs.input.$refs.input.setAttribute('autocomplete', 'on')
  },
}
</script>
<style lang="scss" >
@media (hover: none) {
  #app .el-input-number, #cart-dtawer .el-input-number  {
    &__decrease,
    &__increase {
      &:hover {
        background-color: unset !important;
        i {
          color: unset !important;
        }
      }
    }
  }
}
</style>